module.exports = __webpack_public_path__ + "img/serviceplanner-offers-overlay-de.ffa6277a.webp";